<span [style.display]="!showroomMode && showGrossPrice ? '' :'none'">
  @if (price && price.value > 0) {
    @if (showLabel && !['WG','GHO'].includes(applicationService.getSelectCompanyGroupCode())) {
      {{ 'GROSSPRICE' | translate }}
    }
    @if (showLabel && ['WG','GHO'].includes(applicationService.getSelectCompanyGroupCode())) {
      {{ 'COSTPRICE' | translate }}
    }
    <span [innerHTML]="price.value |  currencyConvert: price.currency"></span>
  }
</span>
